import { useEffect } from 'react';

/**
 * 상하좌우 터치 스크롤 방지
 */
export function usePreventTouchScroll() {
  useEffect(() => {
    const prevTouchAction = document.body.style.touchAction;
    const prevOverflow = document.body.style.overflow;
    const prevOverscrollBehavior = document.body.style.overscrollBehavior;

    document.body.style.touchAction = 'none';
    document.body.style.overflow = 'hidden';
    document.body.style.overscrollBehavior = 'none';

    return () => {
      document.body.style.touchAction = prevTouchAction;
      document.body.style.overflow = prevOverflow;
      document.body.style.overscrollBehavior = prevOverscrollBehavior;
    };
  }, []);
}
